import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";

import { ViewFiltersRequest } from "../types";

/**
 * Checks if the filter has changed by comparing the original and updated filter states.
 *
 * @param originalFilter - The original filter state, can be null if no filter exists.
 * @param updatedFilter - The updated filter state to compare against the original.
 * @returns A boolean indicating whether the filter has changed.
 */
export function hasFilterChanged(
  originalFilter: ViewFiltersRequest | null,
  updatedFilter: ViewFiltersRequest
): boolean {
  /*
    Case 1: New Filter Detection
    If the original filter is null/undefined or lacks an ID, 
    it's considered a new filter or a state before the first save, 
    hence treated as "changed".
  */
  if (!originalFilter?.id) {
    return true;
  }

  const generalChange = !isEqual(originalFilter, updatedFilter);

  const isOriginalFilterSelectAll =
    originalFilter.selectAll && !isEmpty(originalFilter.search);

  const isSelectAllClearedSearchCase =
    updatedFilter.selectAll &&
    updatedFilter.search === "" &&
    isOriginalFilterSelectAll;

  if (isSelectAllClearedSearchCase) {
    const originalWithClearedSearch = { ...originalFilter, search: "" };
    return !isEqual(updatedFilter, originalWithClearedSearch);
  }

  // If it's not the special case, return the result of the general comparison
  return generalChange;
}
